import type { ReactNode } from "react";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useCommunitySwitcherContext } from "../context/CommunitySwitcherContext";
import { CommunitySectionTooltipContent } from "./CommunitySectionTooltipContent";

export interface CommunitySwitcherCommunityListProps {
  readonly children?: ReactNode;
  readonly onClickSeeMyCommunities?: () => void;
  readonly shouldShowShowMoreButton?: boolean;
}

export const CommunitySwitcherCommunityList = ({
  children,
  onClickSeeMyCommunities = () => {},
  shouldShowShowMoreButton,
}: CommunitySwitcherCommunityListProps) => {
  const { t } = useCommunitySwitcherContext();

  return (
    <div className="flex flex-col items-center gap-2">
      {children}
      {shouldShowShowMoreButton ? (
        <Tooltip
          content={
            <CommunitySectionTooltipContent
              name={t("community_switcher_see_my_communities")}
              hotkeyPosition={0}
            />
          }
          delay={200}
          side="right"
          sideOffset={12}
        >
          <IconButton
            aria-label={t("community_switcher_see_my_communities")}
            icon="dot-menu"
            onClick={onClickSeeMyCommunities}
            size="sm"
            variant="ghost"
          />
        </Tooltip>
      ) : null}
    </div>
  );
};
